define('modules/page_generator/views/mobile_preview',['require','exports','module','./base_preview','../service','ldsh!../templates/preview'],function(require, exports, module){
  "use strict";
  var BasePreview = require("./base_preview"),
      PageGenerator = require("../service");

  module.exports = BasePreview.extend({
    template: require("ldsh!../templates/preview"),
    defaultPageHeight: 480,
    onPreviewRender: function(){
      //mobile css tuning
      var pageProperties = this.model.getPropertyGroup("page:defaults"),
           pageWidth = parseInt(pageProperties.get("width")) + 20,
           pageHeight = 480;
      this.$(".js-preview-content").css("height", this.defaultPageHeight + "px");
      this.$(".js-preview-content").css("width", pageWidth + "px");
    }
  });
});
